import { deserialize } from 'cerialize'

interface Options {
	isReset?: boolean
	payload?: string
}

export class LeadFIO {
	@deserialize public fio: string

	constructor(options?: Options) {
		if (!options || options.isReset) {
			this.fio = undefined
		} else {
			this.fio = options.payload
		}
	}
}
